import { Link, type LinkProps } from 'react-router-dom';
import { cn } from '@/utils/cn';
import { BUTTON_SIZE, type ButtonSize, type ButtonVariant } from '@/design-system/tokens';
import type { ReactNode } from 'react';

const variants: Record<ButtonVariant, string> = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  danger: 'btn-danger',
  ghost: 'btn-ghost',
};

export interface ButtonLinkProps extends LinkProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: ReactNode;
}

/** Router link styled as a standard boxed button. */
export function ButtonLink({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...props
}: ButtonLinkProps) {
  return (
    <Link className={cn('btn', variants[variant], BUTTON_SIZE[size], className)} {...props}>
      {children}
    </Link>
  );
}
